import { Fragment } from 'react';

import { FatArrowDown } from 'basic-components/icons';

const ProviderLabel = () => (
  <Fragment>
    <div className="provider-selector__label">
      Source
    </div>
    <div className="provider-selector__arrow">
      <FatArrowDown
          color="blue-bright"
          height={12}
          width={12}
      />
    </div>
  </Fragment>
)
export default ProviderLabel;